import * as React from 'react';
import CenteredPageContainer from '../../components/CenteredPageContainer';
import NavBar from '../../components/NavBar';
import { Container, Col, Collapse, Row } from 'reactstrap';
import FormTitleText from '../../components/FormComponents/FormTitleText';
import FormTitleNumber from '../../components/FormComponents/FormTitleNumber';
import FormDetailText from '../../components/FormComponents/FormDetailText';
import AddressInputForm from '../../components/FormComponents/AddressInputForm';
import DatePicker from '../../components/FormComponents/DatePicker';
import AboutYouForm from '../../components/FormComponents/AboutYouForm';
import ApartmentNumberForm from '../../components/FormComponents/ApartmentNumberForm';
import RectangleButton from 'src/components/Buttons/RectangleButton';
import { Moment } from 'moment';
import { RouteComponentProps } from 'react-router';
import { CreateListingMutation, CreateListingMutationGql } from './Mutations/CreateListingMutation';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { ListingCreateInput } from 'src/schema';

interface state {
  currentStep: number;
  address: string;
  dropoffStartDate: Moment | null;
  dropoffEndDate: Moment | null;
  pickupStartDate: Moment | null;
  pickupEndDate: Moment | null;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

class BecomeAHostPage extends React.Component<RouteComponentProps<any>, state> {
  goToStep = (invalid: boolean, step: number) => {
    if (!invalid) {
      this.setState({ currentStep: step });
    }
  };

  state: state = {
    currentStep: 1,
    address: '',
    dropoffStartDate: null,
    dropoffEndDate: null,
    pickupStartDate: null,
    pickupEndDate: null,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
  };
  render() {
    const invalidAboutYou =
      this.state.firstName === '' ||
      this.state.lastName === '' ||
      this.state.phoneNumber === '' ||
      this.state.email === '';
    const invalidStoragePreference =
      this.state.dropoffStartDate == null ||
      this.state.dropoffEndDate == null ||
      this.state.pickupStartDate == null ||
      this.state.pickupEndDate == null;
    const invalidAboutYourSpace = this.state.address === '';
    return (
      <CreateListingMutation mutation={CreateListingMutationGql}>
        {(createListing, { loading, data }) => (
          <CenteredPageContainer>
            <NavBar />
            <Container style={{ marginTop: 25 }}>
              <Row>
                <Col xs={{ size: 12 }} md={{ size: 4, offset: 4 }}>
                  <div>
                    <FormTitleText
                      isActive={this.state.currentStep >= 1}
                      onClick={() => this.setState({ currentStep: 1 })}
                    >
                      <FormTitleNumber isActive={this.state.currentStep >= 1}>1</FormTitleNumber>
                      About You
                    </FormTitleText>
                    <Collapse isOpen={this.state.currentStep === 1}>
                      <FormDetailText>Let's get to know you a little better.</FormDetailText>
                      <AboutYouForm
                        onChange={(firstName, lastName, phoneNumber, email) => {
                          this.setState({ firstName, lastName, phoneNumber, email });
                        }}
                      />
                      <RectangleButton
                        invalid={invalidAboutYou}
                        onClick={() => this.goToStep(invalidAboutYou, 2)}
                        style={{ marginTop: 20 }}
                      >
                        Next
                      </RectangleButton>
                    </Collapse>
                  </div>

                  <div style={{ paddingTop: 40 }}>
                    <FormTitleText
                      isActive={this.state.currentStep >= 2}
                      onClick={() => this.goToStep(invalidAboutYou, 2)}
                    >
                      <FormTitleNumber isActive={this.state.currentStep >= 2}>2</FormTitleNumber>
                      Your Storage Preference
                    </FormTitleText>
                    <Collapse isOpen={this.state.currentStep === 2}>
                      <FormDetailText>Storage, pickup, and dropoff dates</FormDetailText>
                      <DatePicker
                        style={{ marginTop: 12 }}
                        title="Dropoff date availability"
                        onChange={(dropoffStartDate, dropoffEndDate) => {
                          this.setState({
                            dropoffStartDate,
                            dropoffEndDate,
                          });
                        }}
                      />
                      <DatePicker
                        style={{ marginTop: 12 }}
                        title="Pickup date availability"
                        onChange={(pickupStartDate, pickupEndDate) => {
                          this.setState({
                            pickupStartDate,
                            pickupEndDate,
                          });
                        }}
                      />
                      <RectangleButton
                        invalid={invalidAboutYou || invalidStoragePreference}
                        onClick={() =>
                          this.goToStep(invalidAboutYou || invalidStoragePreference, 3)
                        }
                        style={{ marginTop: 20 }}
                      >
                        Next
                      </RectangleButton>
                    </Collapse>
                  </div>

                  <div style={{ paddingTop: 40 }}>
                    <FormTitleText
                      isActive={this.state.currentStep >= 3}
                      onClick={() => this.goToStep(invalidAboutYou || invalidStoragePreference, 3)}
                    >
                      <FormTitleNumber isActive={this.state.currentStep >= 3}>3</FormTitleNumber>
                      About Your Space
                    </FormTitleText>
                    <Collapse isOpen={this.state.currentStep === 3}>
                      <FormDetailText>Let's get to know your space a little better.</FormDetailText>
                      <AddressInputForm
                        style={{ marginTop: 22 }}
                        onChange={address => this.setState({ address })}
                      />
                      <ApartmentNumberForm style={{ marginTop: 8 }} />
                      <RectangleButton
                        invalid={
                          invalidAboutYou || invalidStoragePreference || invalidAboutYourSpace
                        }
                        onClick={async () => {
                          {
                            if (
                              !(
                                invalidAboutYou ||
                                invalidStoragePreference ||
                                invalidAboutYourSpace
                              )
                            ) {
                              const results = await geocodeByAddress(this.state.address);
                              const { lat, lng } = await getLatLng(results[0]);
                              const listingInputData: ListingCreateInput = {
                                storageDates: {
                                  create: {
                                    dropoffStartDate: this.state.dropoffStartDate!.toISOString(),
                                    dropoffEndDate: this.state.dropoffEndDate!.toISOString(),
                                    pickupStartDate: this.state.pickupStartDate!.toISOString(),
                                    pickupEndDate: this.state.pickupEndDate!.toISOString(),
                                  },
                                },
                                address: this.state.address,
                                location: { create: { latitude: lat, longitude: lng } },
                                price: { create: {} },
                                boxesLeft: 0,
                                owner: {
                                  create: {
                                    firstName: this.state.firstName,
                                    lastName: this.state.lastName,
                                    email: this.state.email,
                                    phoneNumber: this.state.phoneNumber,
                                  },
                                },
                              };
                              createListing({
                                variables: {
                                  data: listingInputData,
                                },
                              });
                              this.props.history.push('/become-a-host/thanks');
                            }
                          }
                        }}
                        style={{ marginTop: 20 }}
                      >
                        Become a Host
                      </RectangleButton>
                    </Collapse>
                  </div>
                </Col>
              </Row>
            </Container>
          </CenteredPageContainer>
        )}
      </CreateListingMutation>
    );
  }
}

export default BecomeAHostPage;



// WEBPACK FOOTER //
// ./src/pages/BecomeAHost/BecomeAHostPage.tsx